<dynamic-component
  #root
  [componentData]="{ question: childQuestion, loopIndex: loopIndex }"
  [wrapperClass]="
    'application-form__question-traverse' + (isIterate() ? ' application-form__question-traverse--inner' : '')
  "
></dynamic-component>
<!-- Recurse through nodes which are not in iterate as iterate-collection handles its immediate children -->
<ng-container *ngIf="!isIterate() && !isDiagnosis()">
  <ng-container *ngFor="let subQuestion of childQuestion.children">
    <ng-container *ngIf="subQuestion.isShown(loopIndex)">
      <application-form-question-traverse
        [childQuestion]="subQuestion"
        [loopIndex]="loopIndex"
      ></application-form-question-traverse>
    </ng-container>
  </ng-container>
</ng-container>
